/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Typography as MuiTypography } from '@mui/material';
import { cx } from '@emotion/css';
import { makeStyles } from '../../../styles';
import { TYPOGRAPHY_DSM_CUSTOM_VARIANTS } from './Typography.constants';
const useStyles = makeStyles(() => TYPOGRAPHY_DSM_CUSTOM_VARIANTS);
function isDsmCustomVariant(variant) {
    if (!variant) {
        return false;
    }
    return Object.keys(TYPOGRAPHY_DSM_CUSTOM_VARIANTS).includes(variant);
}
/**
 * Overrides default material UI typography with some additional variants
 * https://github.com/mui-org/material-ui/issues/22257#issuecomment-776300833
 */
export function Typography(props) {
    const classes = useStyles();
    const commonDefaultProps = {
        align: props.align,
        children: props.children,
        className: props.className,
        color: props.color,
        'data-testid': props.testid,
        id: props.id,
        variant: props.variant,
    };
    if (isDsmCustomVariant(props.variant)) {
        return (React.createElement(MuiTypography, Object.assign({}, commonDefaultProps, { className: cx(classes[props.variant], props.className), variant: undefined })));
    }
    return React.createElement(MuiTypography, Object.assign({}, commonDefaultProps, { variant: props.variant }));
}
//# sourceMappingURL=Typography.js.map